import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const TripsTable = ({ trips = [], userLocation = null }) => {
  const [expandedTrip, setExpandedTrip] = useState(null);

  const getStatusBadge = (status) => {
    const statusConfig = {
      upcoming: {
        label: 'Yaklaşan',
        icon: 'Clock',
        bgColor: 'bg-primary/10',
        textColor: 'text-primary',
        iconColor: 'var(--color-primary)'
      },
      active: {
        label: 'Aktif',
        icon: 'Navigation',
        bgColor: 'bg-success/10',
        textColor: 'text-success',
        iconColor: 'var(--color-success)'
      },
      passed: {
        label: 'Geçti',
        icon: 'CheckCircle',
        bgColor: 'bg-muted',
        textColor: 'text-muted-foreground',
        iconColor: 'var(--color-muted-foreground)'
      }
    };

    const config = statusConfig?.[status] || statusConfig?.upcoming;

    return (
      <div className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full ${config?.bgColor}`}>
        <Icon name={config?.icon} size={14} color={config?.iconColor} />
        <span className={`text-xs font-medium ${config?.textColor}`}>{config?.label}</span>
      </div>
    );
  };

  const handleTripToggle = (tripId) => {
    setExpandedTrip(expandedTrip === tripId ? null : tripId);
  };

  return (
    <div className="bg-card rounded-xl border border-border overflow-hidden">
      <div className="p-4 md:p-6 border-b border-border">
        <div className="flex items-center gap-3">
          <div className="flex items-center justify-center w-10 h-10 bg-primary/10 rounded-lg">
            <Icon name="Calendar" size={20} color="var(--color-primary)" />
          </div>
          <div>
            <h3 className="text-lg md:text-xl font-bold text-foreground">Sefer Saatleri</h3>
            <p className="text-sm text-muted-foreground">Güncel sefer programı</p>
          </div>
        </div>
      </div>
      <div className="hidden md:block overflow-x-auto">
        <table className="w-full">
          <thead className="bg-muted/50">
            <tr>
              <th className="px-6 py-4 text-left text-sm font-semibold text-foreground">Kalkış Saati</th>
              <th className="px-6 py-4 text-left text-sm font-semibold text-foreground">Durum</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {trips?.map((trip) => (
              <tr key={trip?.id} className="hover:bg-muted/30 transition-smooth">
                <td className="px-6 py-4">
                  <div className="flex items-center gap-2">
                    <Icon name="Clock" size={16} color="var(--color-foreground)" />
                    <span className="text-sm font-medium text-foreground">{trip?.startTime}</span>
                  </div>
                </td>
                <td className="px-6 py-4">
                  {getStatusBadge(trip?.status)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="md:hidden divide-y divide-border">
        {trips?.map((trip) => (
          <div key={trip?.id} className="p-4">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <Icon name="Clock" size={16} color="var(--color-primary)" />
                <span className="text-sm font-semibold text-foreground">{trip?.startTime}</span>
              </div>
              {getStatusBadge(trip?.status)}
            </div>
          </div>
        ))}
      </div>
      <div className="p-4 md:p-6 bg-muted/30 border-t border-border">
        <div className="flex items-start gap-2">
          <Icon name="Info" size={16} color="var(--color-muted-foreground)" className="mt-0.5 flex-shrink-0" />
          <p className="text-xs text-muted-foreground">
            Sefer saatleri programlanmış verilere dayanmaktadır. 
            Trafik koşullarına göre değişiklik gösterebilir.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TripsTable;